import { defineStore } from 'pinia'

import type { AssessmentResultStore } from './interfaces'

import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

import { actions } from './actions'
import { getters } from './getters'

export const useAssessmentResultStore = defineStore('assessment-result', {
  state: (): AssessmentResultStore => ({
    id: null,
    loading: false,
    questions: [],
    comprehension: false,
    assessmentUrls: {
      math: null,
      ela: null,
    },
    score: 0,
    variant: Discipline.Math,
  }),
  actions,
  getters,
})
